
import React, { useEffect, useState } from 'react';
import { FaMapMarker } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { urlWebsite } from '../../../../config';
import { useConfiguration } from '../../../../hooks/Configuration';
import { useLanguage } from '../../../../hooks/Language';
import { ApoioImg } from '../../../../pages/SponsorsPage/styles';
import {

    Capa, Container,



} from './styles';

const HomeApplicationLanding = () => {
    const { configuration, projectHash } = useConfiguration();
    const { translate } = useLanguage();
    const event = configuration?.current_event_id_response;
    const dates = event?.date_text ? event?.date_text?.split('|') : [];

    const [theme, setTheme] = useState({
        titleColor: configuration?.current_event_id_response?.theme?.title_color || '#fff',
        textColor: configuration?.current_event_id_response?.theme?.text_color || '#fff',
        buttonColor: configuration?.current_event_id_response?.theme?.button_color || 'rgb(78, 27, 129)',
        buttonBackground: configuration?.current_event_id_response?.theme?.button_background || '#3FB8EB',
    })


    useEffect(() => {
        setTheme({
            titleColor: configuration?.current_event_id_response?.theme?.title_color || '#fff',
            textColor: configuration?.current_event_id_response?.theme?.text_color || '#fff',
            buttonColor: configuration?.current_event_id_response?.theme?.button_color || 'rgb(78, 27, 129)',
            buttonBackground: configuration?.current_event_id_response?.theme?.button_background || '#3FB8EB',
        })
    }, [configuration])


    return <Container>
        <Capa>
            <div className='header'>
                <div style={{ marginBottom: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                    {event?.images && event?.images?.length > 0 && event?.images?.map(image => {

                        return <ApoioImg key={image?.url} src={`${urlWebsite}/${image?.url}`} computer={image?.computer} mobile={image?.mobile} />

                    })}
                </div>
                {event?.images?.length > 0 ? <div className='separator' /> : <></>}

                {event?.category ? <div className='headerCategory' dangerouslySetInnerHTML={{ __html: event?.category }} /> : <></>}
                <div className='separator' />
                {event?.subtitle ? <h4 className='headerSubtitle'>{event?.subtitle}</h4> : <></>}

                {event?.title ? <h3 className='headerTitle'>{event?.title}</h3> : <></>}

                {dates?.length > 0 ? <div className='headerDates'>
                    {dates?.map((date, dateIndex) => <p key={`home_${date}_${dateIndex}`}>{date}</p>)}
                </div> : <></>}

                <div className="headerButtons">{configuration?.active_pages && configuration?.active_pages?.map(button => {
                    return button?.button !== 'yes' ? <></> : button?.type === 'external' ? <a href={button.url} target="_BLANK" ><button className='greenButton2 shadow' style={{ background: theme?.buttonBackground, color: theme?.buttonColor, margin: '0px' }}>{button?.title}</button></a> : <Link to={`/app/${projectHash}/${button.url}`} ><button className='greenButton2 shadow' style={{ background: theme?.buttonBackground, color: theme?.buttonColor, margin: '0px' }}>{button?.title}</button></Link>
                })}
                </div></div>



            {configuration?.current_event_id_response?.image ? <img style={{ maxWidth: '650px', width: '100%' }} src={configuration?.current_event_id_response?.image ? `${urlWebsite}/${configuration?.current_event_id_response?.image}` : '/assets/logo.png'} /> : <></>}





        </Capa>
        {configuration?.current_event_id_response?.local ? <div className='localDiv'>
            <FaMapMarker size={30} color={"#fff"} />
            <div>
                <p className='mapiconP'> {translate(configuration?.current_event_id_response?.local)} {configuration?.current_event_id_response?.local_description ? <> <br />
                    {translate(configuration?.current_event_id_response?.local_description)}</> : <></>}  </p>


            </div>

        </div> : <></>}

    </Container>

}

export default HomeApplicationLanding;